/* eslint-disable react/react-in-jsx-scope */
import { AppBar, Toolbar, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { NavLink } from 'react-router-dom'
import logo from '../../assets/images/tisoha_logo.png'

import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import CloseIcon from '@material-ui/icons/Close'
import MenuIcon from '@material-ui/icons/Menu'
import { useEffect, useState } from 'react'
import '../../scss/styles.scss'
import PrimaryButton from '../buttons/PrimaryButton'
import TwinklingStars from '../BackgroundEffects/TwinklingStars'

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: '"Inter", sans-serif',
    flexGrow: 1
  },
  appbar: {
    background: 'transparent',
    boxShadow: 'none',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),

    '&.scrolled': {
      background: 'rgba(10, 10, 10, 0.75)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.4)'
    }
  },
  appbarWrapper: {
    maxWidth: 1400,
    margin: '0 auto !important',
    width: '80%',
    padding: '0 !important',
    [theme.breakpoints.down('lg')]: {
      width: '85%'
    },
    [theme.breakpoints.down('md')]: {
      width: '90%'
    },
    [theme.breakpoints.down('sm')]: {
      width: '92%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '95%'
    }
  },
  title: {
    flexGrow: 1
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.02)'
    },
    '&:hover img': {
      filter: 'drop-shadow(0 0 10px rgba(45, 170, 103, 0.5))'
    }
  },
  logo: {
    height: 48,
    width: 'auto',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      height: 36
    }
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  smallMenu: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  link: {
    color: 'rgba(255, 255, 255, 0.8)',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontWeight: 500,
    fontSize: '13px',
    letterSpacing: '0.08em',
    lineHeight: '24px',
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    position: 'relative',
    transition: 'all 0.3s ease',

    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 4,
      left: '50%',
      transform: 'translateX(-50%) scaleX(0)',
      width: '60%',
      height: 2,
      background: 'linear-gradient(90deg, #2DAA67, #00D4FF)',
      borderRadius: 2,
      transition: 'transform 0.3s ease'
    },

    '&:hover': {
      color: '#fff',
      background: 'rgba(255, 255, 255, 0.05)'
    },

    '&:hover::after': {
      transform: 'translateX(-50%) scaleX(1)'
    },

    '&.active': {
      color: '#fff',
      fontWeight: 700,
      '&::after': {
        transform: 'translateX(-50%) scaleX(1)',
        background: 'linear-gradient(90deg, #2DAA67, #00D4FF)',
        height: 3
      }
    },

    [theme.breakpoints.up('lg')]: {
      fontSize: '14px',
      padding: theme.spacing(1, 2.5)
    },
    [theme.breakpoints.between('md', 'lg')]: {
      fontSize: '12px',
      padding: theme.spacing(0.8, 1.5)
    }
  },
  nameCompany: {
    color: '#E2E8F0',
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontSize: '15px',
    fontWeight: 800,
    letterSpacing: '0.14em',
    lineHeight: '24px',
    marginLeft: theme.spacing(1.5),
    filter: 'drop-shadow(0 0 6px rgba(255, 255, 255, 0.4))',
    transition: 'all 0.3s ease',

    [theme.breakpoints.up('lg')]: {
      fontSize: '15px'
    },
    [theme.breakpoints.between('sm', 'md')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
      display: 'block',
      marginLeft: theme.spacing(1),
      letterSpacing: '0.05em',
      lineHeight: '1.2',
      maxWidth: 150
    }
  },
  menuButton: {
    color: 'white',
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: 12,
    padding: theme.spacing(1),
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(45, 170, 103, 0.2)',
      transform: 'scale(1.05)'
    }
  },
  drawer: {
    '& .MuiDrawer-paper': {
      width: 280,
      background: 'linear-gradient(145deg, #0a0a0a 0%, #121212 100%)',
      borderLeft: '1px solid rgba(255, 255, 255, 0.08)',
      overflow: 'hidden',
      boxShadow: '-10px 0 50px rgba(0, 0, 0, 0.8)',

      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 100% 0%, rgba(45, 170, 103, 0.12) 0%, transparent 60%), radial-gradient(circle at 0% 100%, rgba(0, 212, 255, 0.05) 0%, transparent 60%)',
        pointerEvents: 'none',
        zIndex: 0
      }
    }
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(2, 2.5),
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    position: 'relative',
    zIndex: 1
  },
  drawerLogo: {
    height: 36,
    filter: 'brightness(1.2)'
  },
  closeButton: {
    color: 'rgba(255, 255, 255, 0.7)',
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: 10,
    transition: 'all 0.3s ease',
    '&:hover': {
      color: '#fff',
      background: 'rgba(255, 95, 115, 0.2)'
    }
  },
  drawerList: {
    padding: theme.spacing(2),
    position: 'relative',
    zIndex: 1
  },
  drawerItem: {
    color: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 12,
    marginBottom: theme.spacing(1),
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(45, 170, 103, 0.1)',
      '& .MuiListItemText-primary': {
        color: '#2DAA67'
      }
    },
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: '15px',
      letterSpacing: '0.05em',
      transition: 'color 0.3s ease'
    }
  },
  drawerContactBtn: {
    margin: theme.spacing(3, 4),
    background: 'linear-gradient(135deg, #2DAA67 0%, #228B53 100%)',
    borderRadius: 50,
    padding: '10px 24px',
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(45, 170, 103, 0.3)',

    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(45, 170, 103, 0.4)',
      background: 'linear-gradient(135deg, #3DBC79 0%, #2DAA67 100%)'
    },

    '& .MuiListItemText-primary': {
      fontWeight: 700,
      fontSize: '13px',
      letterSpacing: '0.05em',
      textAlign: 'center'
    }
  }
}))

export default function Header() {
  const classes = useStyles()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToContactForm = () => {
    const element = document.getElementById('contactForm')
    if (element) {
      // Offset to account for fixed header + small gap
      // Using a smaller offset (-80 instead of -180) to give more room at the bottom
      const yOffset = -80
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
    setDrawerOpen(false)
  }

  const menuItems = [
    { label: 'HOME', path: '/', exact: true },
    { label: 'SERVICES', path: '/services', exact: true },
    {
      label: 'PORTFOLIO',
      path: '/portfolio',
      exact: true,
      isActive: (match, location) => {
        if (!match) return false
        const query = new URLSearchParams(location.search)
        return match.isExact && query.get('filter') !== 'ai'
      }
    },
    {
      label: 'AI',
      path: '/portfolio?filter=ai',
      exact: false,
      isActive: (match, location) => {
        if (!location) return false
        const query = new URLSearchParams(location.search)
        return location.pathname === '/portfolio' && query.get('filter') === 'ai'
      }
    },
    { label: 'INDUSTRIES', path: '/industries', exact: true },
    { label: 'MEMBERS', path: '/members', exact: true }
  ]

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={`${classes.appbar} ${scrolled ? 'scrolled' : ''}`}>
        <Toolbar className={classes.appbarWrapper}>
          <Typography className={classes.title}>
            <NavLink className={classes.logoContainer} to="/">
              <img alt="Tisoha" src={logo} className={classes.logo} />
              <span className={classes.nameCompany}>TISOHA SOFTWARE SOLUTIONS</span>
            </NavLink>
          </Typography>

          <div className={classes.menu}>
            {menuItems.map((item, index) => (
              <NavLink
                key={index}
                className={classes.link}
                exact={item.exact}
                to={item.path}
                activeClassName="active"
                isActive={item.isActive}
              >
                {item.label}
              </NavLink>
            ))}
            <div style={{ marginLeft: 8 }}>
              <PrimaryButton
                text={'contact us'}
                isContactButton={true}
                onClick={scrollToContactForm}
              />
            </div>
          </div>

          <div className={classes.smallMenu}>
            <IconButton
              className={classes.menuButton}
              edge="start"
              aria-label="menu"
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>

            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
              className={classes.drawer}
              disableScrollLock
            >
              <TwinklingStars count={25} />
              <div className={classes.drawerHeader}>
                <IconButton
                  className={classes.closeButton}
                  onClick={() => setDrawerOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              </div>

              <List className={classes.drawerList}>
                {menuItems.map((item, index) => (
                  <ListItem
                    key={index}
                    button
                    component={NavLink}
                    exact={item.exact}
                    to={item.path}
                    isActive={item.isActive}
                    onClick={() => setDrawerOpen(false)}
                    className={classes.drawerItem}
                  >
                    <ListItemText primary={item.label} />
                  </ListItem>
                ))}
                <ListItem
                  button
                  onClick={scrollToContactForm}
                  className={classes.drawerContactBtn}
                >
                  <ListItemText primary="CONTACT US" />
                </ListItem>
              </List>
            </Drawer>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}
